<mat-progress-bar mode="indeterminate" *ngIf="loading"></mat-progress-bar>
<div class="spinner" *ngIf="loading"><mat-progress-spinner mode="indeterminate"></mat-progress-spinner></div>

<div class="mobile-bottom" [ngClass]="viewport.type === 'desktop' ? 'mb-3' : 'mb-2'" *ngIf="!loading" appObserveElement #adList="intersection">
	<div class="col-sm-4 col-md-8 col-lg-12 px-2">
		<app-ads-banner></app-ads-banner>
	</div>

	<div class="row mt-4 mx-0">
		<!-- <div class="left-section col-lg-auto col-12"> -->
		<div class="left-section col-lg-3 col-sm-12 px-0">
			<div class="px-1 pb-2 d-flex justify-content-between align-items-center" *ngIf="viewport.type === 'desktop'">
				<span class="fs-16px fw-500 fg-grey my-1">{{ locale.translations['n739'] }}</span>
				<!-- <button class="float-end fg-purple" label="Reset all" mat-flat-button (click)="onReset()">Reset Filters</button> -->
			</div>
			<!-- Filter Component -->
			<div class="w-100">
				<app-filter [isFilterReset]="isFilterReset" [sortBy]="sortBy"></app-filter>
			</div>
		</div>
		<div class="col-lg-9 col-12 px-0">
			<div class="row mx-0 justify-content-between d-flex align-items-center">
				<div class="col-auto fs-24px fw-500" [ngClass]="{ 'fs-16px my-2': viewport.type !== 'desktop' }">
					{{ ads['totalRows'] }} {{ locale.translations['n742'] }}
				</div>
				<div
					class="col-auto fg-purple"
					[ngClass]="{ 'text-start': locale.lang !== 'en', 'text-end': locale.lang === 'en', 'my-2': viewport.type !== 'desktop' }"
				>
					<button [matMenuTriggerFor]="sortList" mat-flat-button class="text-center px-0 fg-purple fw-400 fs-14px v2">
						<mat-icon class="mat-icon-rtl-mirror fs-18px">sort</mat-icon>
						<span>{{ locale.translations['ads']['filter']['n32']['n32-1'] }}: {{ sortBy.sortValue }}</span>
					</button>
				</div>
			</div>
			<div class="row mx-0">
				<ng-container *ngFor="let ad of ads['data']; let i = index">
					<ng-template [ngIf]="!ad?.isGoogleAd" [ngIfElse]="googleAdsense">
						<!-- AD item -->
						<div class="col-sm-4 px-2 my-2 col-md-4 col-lg-3" *ngIf="ad['vipPlus'] === '0'">
							<app-ad-item [ad]="ad"></app-ad-item>
						</div>

						<div class="col-12 my-2 px-2" *ngIf="ad['vipPlus'] === '1'">
							<app-ad-item-v2 [ad]="ad"></app-ad-item-v2>
						</div>

						<!-- AD banner -->
						<div class="col-sm-4 my-2 px-2 col-md-4 col-lg-3" *ngIf="viewport.type === 'mobile' && (i + 1) % 8 === 0">
							<app-ad-item-banner></app-ad-item-banner>
						</div>
					</ng-template>

					<!-- <div> -->
					<ng-template #googleAdsense>
						<div *ngIf="googleAdEnv.isEnabled && viewport.type === 'mobile'" class="col-sm-4 px-2 my-2 col-md-4 col-lg-3">
							<app-google-ad [type]="googleAd.FEED"></app-google-ad>
						</div>
					</ng-template>
					<!-- </div> -->
				</ng-container>
			</div>

			<div
				appObserveElement
				[debounceTime]="100"
				(isIntersecting)="onAdsPaginationIntersect($event, adList._isIntersecting)"
				#scrollTrigger
				class="trigger-element"
			></div>

			<div class="spinner" *ngIf="isMoreAdsLoading">
				<mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
			</div>

			<!-- no results -->
			<div class="mdc-layout-grid__cell--span-12" *ngIf="ads['data'] && ads['data'].length === 0">
				<div class="mdc-layout-grid__inner center">
					<div class="mdc-layout-grid__cell--span-12">
						<mat-icon class="large">search</mat-icon>
					</div>

					<div class="mdc-layout-grid__cell--span-12">
						<h4 id="n19">{{ locale.translations['ads']['n19'] }}</h4>
					</div>

					<div class="mdc-layout-grid__cell--span-12">
						<a mat-flat-button color="primary" [routerLink]="['./']" id="n20">
							{{ locale.translations['ads']['n20'] }}
						</a>
					</div>
				</div>
			</div>

			<div
				class="col-lg-12 col-md-8 col-sm-4 my-4 mx-3"
				*ngIf="!loading"
				[debounceTime]="100"
				appObserveElement
				(isIntersecting)="onGoogleAdBannerIntersect($event, adList._isIntersecting)"
			>
				<app-google-ad [type]="googleAd.BANNER"></app-google-ad>
			</div>
		</div>

		<mat-menu #sortList="matMenu" class="ad-filter-menu" xPosition="before">
			<button mat-menu-item class="border-bottom" (click)="onOpenSort(1, true)">
				<div class="option-content">
					<span>{{ locale.translations['ads']['filter']['n32']['n32-2'] | titlecase }}</span>
					<mat-icon class="fg-purple fs-20px mx-0" *ngIf="selectedSortOption === 1">check</mat-icon>
				</div>
			</button>
			<button mat-menu-item class="border-bottom" (click)="onOpenSort(0, true)">
				<div class="option-content">
					<span>{{ locale.translations['ads']['filter']['n32']['n32-3'] }}</span>
					<mat-icon class="fg-purple fs-20px mx-0" *ngIf="selectedSortOption === 0">check</mat-icon>
				</div>
			</button>
			<button mat-menu-item class="border-bottom" (click)="onOpenSort(2, true)">
				<div class="option-content">
					<span>{{ locale.translations['ads']['filter']['n32']['n427'] }}</span>
					<mat-icon
						class="fg-purple fs-20px mx-0"
						[ngClass]="{ 'text-end': locale.lang === 'en', 'text-start': locale.lang !== 'en' }"
						*ngIf="selectedSortOption === 2"
					>
						check
					</mat-icon>
				</div>
			</button>
			<button mat-menu-item class="border-bottom" (click)="onOpenSort(3, true)">
				<div class="option-content">
					<span>{{ locale.translations['ads']['filter']['n32']['n426'] }}</span>
					<mat-icon
						class="fg-purple fs-20px mx-0"
						[ngClass]="{ 'text-end': locale.lang === 'en', 'text-start': locale.lang !== 'en' }"
						*ngIf="selectedSortOption === 3"
					>
						check
					</mat-icon>
				</div>
			</button>
		</mat-menu>
	</div>

	<div class="col-12">
		<app-inner-footer></app-inner-footer>
	</div>
</div>
